<script lang="ts">
	import { SUPPORTED_PROJECTOR_MAKES, type ProjectorMake } from "projector-commands"

	interface Props {
		onSelect: (make: ProjectorMake) => void
		selected: ProjectorMake
	}

	let { onSelect, selected }: Props = $props()
</script>

<div class="select-container">
	<label for="make-selector">Projector Make: </label>
	<select
		name="projector_make"
		id="projector-make"
		value={selected}
		onchange={(e) => {
			console.log("select", e.currentTarget.value)
			onSelect(e.currentTarget.value as ProjectorMake)
		}}
	>
		<option value="n/a">-- select make --</option>
		{#each SUPPORTED_PROJECTOR_MAKES as make}
			<option value={make}>{make}</option>
		{/each}
	</select>
</div>

<style>
	.select-container {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 0.5rem;
	}
</style>
